// import React, { useEffect, useState, useRef, useMemo } from "react";
// import {
//     Box, Grid, Typography, Table, TableBody, TableCell, TableContainer,
//     TableHead, TableRow, Paper, Divider, Dialog, DialogContent, DialogActions,
//     Button, TextField, TableSortLabel
// } from "@mui/material";
// import axios from "axios";
// import io from "socket.io-client";
// import * as XLSX from 'xlsx';
// import SearchBar from "../../../../Common/UtilityCommon/SearchBar";
// import { formatReadableAmount } from "../../../../Common/FormatFunctions/FormatAmount";
// import AccountMasterHelp from "../../../../Helper/AccountMasterHelp";
// import PrintButton from "../../../../Common/Buttons/PrintPDF";

// // PDF Generator Imports
// import { generateReportPDF } from "../../../../Common/ReportCommon/CommonPDFGenerator";
// import { ConvertNumberToWord } from "../../../../Common/FormatFunctions/ConvertNumberToWord";
// import HeaderJK from '../../../../Assets/HeaderJK.png';
// import FooterJK from '../../../../Assets/FooterJK.png';

// const headerCellStyle = {
//     fontWeight: "bold",
//     backgroundColor: "#3f51b5",
//     color: "white",
//     padding: "4px",
//     fontSize: "0.75rem",
//     textAlign: "center",
// };

// const LiveAllTendersForDailyBasis = () => {
//     const apikey = process.env.REACT_APP_API;
//     const socketURL = process.env.REACT_APP_API_URL;
//     const company_code = sessionStorage.getItem("Company_Code");
//     const year_code = sessionStorage.getItem("Year_Code");

//     const [tenders, setTenders] = useState([]);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [openEdit, setOpenEdit] = useState(false);
//     const [netAmount, setNetAmount] = useState("0.00");
//     const [sortConfig, setSortConfig] = useState({ key: 'Sauda_Date', direction: 'desc' });

//     const [formData, setFormData] = useState({
//         Tender_No: "", Buyer: "", ShipTo: "", Buyer_Party: "", sub_broker: "",
//         buyerid: "", buyerpartyid: "", sbr: "", shiptoid: "", Buyer_Quantal: "",
//         Sale_Rate: "", Commission_Rate: "", gst_rate: 5.0, tcs_rate: 0.1,
//         gst_amt: 0.0, tcs_amt: 0.0, Delivery_Type: "C",
//         Sauda_Date: new Date().toISOString().split("T")[0],
//         Lifting_Date: new Date().toISOString().split("T")[0],
//         Narration: "", Sauda_Time: new Date().toLocaleTimeString("en-GB", { hour12: false }),
//         EbuySelectedParty: "", EbuySelectedAccoid: "", EbuySugarLiftingDate: "",
//         Payment_To: "", pt: "",
//     });

//     const [millName, setMillName] = useState("");
//     const [buyerName, setBuyerName] = useState("");
//     const [shipToName, setShipToName] = useState("");
//     const [brokerName, setBrokerName] = useState("");
//     const [subBrokerName, setSubBrokerName] = useState("");
//     const [tenderdetailid, settenderDetailId] = useState(0);
//     const [tenderNo, setTenderNo] = useState(0);
//     const [selectedPartyName, setSelectedPartyName] = useState("");

//     const fetchTenders = async () => {
//         try {
//             const res = await axios.get(
//                 `${apikey}/get_live_tendersall?Company_Code=${company_code}&Year_Code=${year_code}`
//             );
//             if (res.data.all_data) {
//                 setTenders(res.data.all_data);
//             }
//         } catch (err) {
//             console.error("Error fetching tenders:", err);
//         }
//     };

//     useEffect(() => {
//         const socket = io(`${socketURL}`, { transports: ["websocket"] });
//         socket.on("tender_added", fetchTenders);
//         socket.on("tender_updated", fetchTenders);
//         socket.on("tender_deleted", fetchTenders);
//         fetchTenders();
//         return () => socket.disconnect();
//     }, []);

//     const handleSort = (key) => {
//         let direction = 'asc';
//         if (sortConfig.key === key && sortConfig.direction === 'asc') {
//             direction = 'desc';
//         }
//         setSortConfig({ key, direction });
//     };

//     const calculateRowProfit = (row) => {
//         const purcRate = parseFloat(row?.Purc_Rate) || 0;
//         const millRate = parseFloat(row?.Mill_Rate) || 0;
//         const saleRate = parseFloat(row?.Sale_Rate) || 0;
//         const quantity = parseFloat(row?.Qntl) || 0;
//         const effectivePurchaseRate = purcRate > 0 ? purcRate : millRate;
//         const profit = (saleRate - effectivePurchaseRate) * quantity;
//         return isNaN(profit) ? 0 : parseFloat(profit.toFixed(2));
//     };

//     const processedData = useMemo(() => {
//         let filteredData = tenders.filter((item) =>
//             Object.values(item).some((val) =>
//                 String(val).toLowerCase().includes(searchTerm.toLowerCase())
//             )
//         );

//         if (sortConfig.key) {
//             filteredData.sort((a, b) => {
//                 let aVal = a[sortConfig.key];
//                 let bVal = b[sortConfig.key];
//                 if (!isNaN(aVal) && !isNaN(bVal)) {
//                     aVal = parseFloat(aVal);
//                     bVal = parseFloat(bVal);
//                 }
//                 if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
//                 if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
//                 return 0;
//             });
//         }
//         return filteredData;
//     }, [tenders, searchTerm, sortConfig]);

//     const groupedData = useMemo(() => {
//         const grouped = {};
//         processedData.forEach((item) => {
//             if (!grouped[item.Sauda_Date]) grouped[item.Sauda_Date] = [];
//             grouped[item.Sauda_Date].push(item);
//         });
//         return grouped;
//     }, [processedData]);

//    const handlePrint = () => {
//     const columns = ["No", "Date", "Mill", "Buyer", "DO", "Qty", "Grd", "M.Rate", "P.Rate", "S.Rate", "P&L"];
//     const rows = [];
//     let grandTotalQty = 0;
//     let grandTotalProfit = 0;

//     const yellowStyle = { 
//         fillColor: [255, 249, 196], 
//         fontStyle: 'bold' 
//     };

//     Object.entries(groupedData).forEach(([date, group]) => {
//         let subQty = 0;
//         let subProfit = 0;
        
//         group.forEach(item => {
//             const profit = calculateRowProfit(item);
//             subQty += parseFloat(item.Qntl || 0);
//             subProfit += profit;
            
//             rows.push([
//                 item.Tender_No, item.Sauda_Date, item.Mill, item.buyerName, item.DO,
//                 { content: formatReadableAmount(item.Qntl), styles: { halign: 'right' } },
//                 item.Grade,
//                 { content: formatReadableAmount(item.Mill_Rate), styles: { halign: 'right' } },
//                 { content: formatReadableAmount(item.Purc_Rate || item.Mill_Rate), styles: { halign: 'right' } },
//                 { content: formatReadableAmount(item.Sale_Rate), styles: { halign: 'right' } },
//                 { content: formatReadableAmount(profit.toFixed(2)), styles: { halign: 'right', fontStyle: 'bold' } }
//             ]);
//         });

//         // 1. Date-wise Sub-Total Row (YELLOW)
//         rows.push([
//             { content: `Total for ${date}:`, colSpan: 5, styles: { ...yellowStyle, halign: 'right' } },
//             { content: formatReadableAmount(subQty.toFixed(2)), styles: { ...yellowStyle, halign: 'right' } },
//             { content: '', colSpan: 4, styles: yellowStyle },
//             { content: formatReadableAmount(subProfit.toFixed(2)), styles: { ...yellowStyle, halign: 'right' } }
//         ]);

//         // 2. Dotted Separator Row
//         // We use a colSpan across all 11 columns and a string of dots
//         rows.push([
//             { 
//                 content: '------------------------------------------------------------------------------------------------------------------------------------------------------------------', 
//                 colSpan: 11, 
//                 styles: { 
//                     halign: 'center', 
//                     textColor: [150, 150, 150], // Light gray color
//                     fontSize: 8,
//                     cellPadding: 1 // Tighten the space around the dots
//                 } 
//             }
//         ]);

//         grandTotalQty += subQty;
//         grandTotalProfit += subProfit;
//     });

//     generateReportPDF({
//         title: 'Daily Sauda Report',
//         columns,
//         rows,
//         footerRow: [
//             { content: 'GRAND TOTAL', colSpan: 5, styles: { ...yellowStyle, halign: 'right' } },
//             { content: formatReadableAmount(grandTotalQty.toFixed(2)), styles: { ...yellowStyle, halign: 'right' } },
//             { content: '', colSpan: 4, styles: yellowStyle },
//             { content: formatReadableAmount(grandTotalProfit.toFixed(2)), styles: { ...yellowStyle, halign: 'right' } }
//         ],
//         orientation: 'landscape',
//         headerImgSrc: HeaderJK,
//         footerImgSrc: FooterJK,
//         styles: { fontSize: 7 },
//         onComplete: (url) => window.open(url, "_blank"),
//     });
// };
//     const handleExportExcel = () => {
//         const data = processedData.map(item => ({
//             "Tender No": item.Tender_No,
//             "Sauda Date": item.Sauda_Date,
//             "Mill": item.Mill,
//             "Buyer": item.buyerName,
//             "DO": item.DO,
//             "Quantity": item.Qntl,
//             "Grade": item.Grade,
//             "Mill Rate": item.Mill_Rate,
//             "Purchase Rate": item.Purc_Rate || item.Mill_Rate,
//             "Sale Rate": item.Sale_Rate,
//             "Profit/Loss": calculateRowProfit(item)
//         }));
//         const ws = XLSX.utils.json_to_sheet(data);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Daily Sauda");
//         XLSX.writeFile(wb, "Daily_Sauda_Report.xlsx");
//     };

//     const handleSaveEdit = async () => {
//         try {
//             await axios.put(`${apikey}/update_tender_detail`, {
//                 detailData: { ...formData, Company_Code: company_code, Year_Code: year_code, tenderdetailid, Tender_No: tenderNo },
//             });
//             setOpenEdit(false);
//             fetchTenders();
//             alert("Tender updated successfully!");
//         } catch (err) {
//             alert("Error updating tender!");
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));
//     };

//     return (
//         <Box sx={{ mt: -10}}>
//             <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 'bold', color: '#3f51b5' }}>
//                 DATE WISE DAILY SAUDA REPORT
//             </Typography>

//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }} style={{ marginLeft: '600px' }}>
//                 <Box sx={{ flexGrow: 1, maxWidth: '600px' }}>
//                     <SearchBar value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
//                 </Box>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                     <PrintButton fetchData={handlePrint} />
//                     <Button
//                         variant="contained"
//                         color="success"
//                         onClick={handleExportExcel}
//                         sx={{ textTransform: 'none', fontWeight: 'bold', height: '35px' }}
//                     >
//                         Export Excel
//                     </Button>
//                 </Box>
//             </Box>


//             <Paper elevation={3} sx={{ mx: 2 }}>
//                 <TableContainer sx={{ maxHeight: "75vh" }}>
//                     <Table size="small" stickyHeader>
//                         <TableHead>
//                             <TableRow>
//                                 {[
//                                     { id: 'Tender_No', label: 'Tender No' },
//                                     { id: 'Sauda_Date', label: 'Sauda Date' },
//                                     { id: 'Sauda_Time', label: 'Time' },
//                                     { id: 'Mill', label: 'Mill Name' },
//                                     { id: 'buyerName', label: 'Buyer Name' },
//                                     { id: 'DO', label: 'DO Name' },
//                                     { id: 'Qntl', label: 'Quintal' },
//                                     { id: 'Grade', label: 'Grade' },
//                                     { id: 'Mill_Rate', label: 'Mill Rate' },
//                                     { id: 'Purc_Rate', label: 'Purc Rate' },
//                                     { id: 'Sale_Rate', label: 'Sale Rate' },
//                                     { id: 'profit', label: 'Profit & Loss' }
//                                 ].map((col) => (
//                                     <TableCell key={col.id} sx={headerCellStyle}>
//                                         <TableSortLabel
//                                             active={sortConfig.key === col.id}
//                                             direction={sortConfig.key === col.id ? sortConfig.direction : 'asc'}
//                                             onClick={() => handleSort(col.id)}
//                                             sx={{ '& .MuiTableSortLabel-icon': { color: 'white !important' }, color: 'white !important' }}
//                                         >
//                                             {col.label}
//                                         </TableSortLabel>
//                                     </TableCell>
//                                 ))}
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {Object.entries(groupedData).map(([date, group], gIdx) => (
//                                 <React.Fragment key={date}>
//                                     {group.map((item, idx) => {
//                                         const rowProfit = calculateRowProfit(item);
//                                         return (
//                                             <TableRow key={`${gIdx}-${idx}`} hover>
//                                                 <TableCell sx={{ fontSize: '0.75rem' }}>{item.Tender_No}</TableCell>
//                                                 <TableCell sx={{ fontSize: '0.75rem' }}>{item.Sauda_Date}</TableCell>
//                                                 <TableCell sx={{ fontSize: '0.75rem' }}>{item.Sauda_Time}</TableCell>
//                                                 <TableCell sx={{ fontSize: '0.75rem' }}>{item.Mill}</TableCell>
//                                                 <TableCell sx={{ fontSize: '0.75rem' }}>{item.buyerName}</TableCell>
//                                                 <TableCell sx={{ fontSize: '0.75rem' }}>{item.DO}</TableCell>
//                                                 <TableCell align="right" sx={{ fontSize: '0.75rem' }}>{item.Qntl}</TableCell>
//                                                 <TableCell sx={{ fontSize: '0.75rem' }}>{item.Grade}</TableCell>
//                                                 <TableCell align="right" sx={{ fontSize: '0.75rem' }}>{item.Mill_Rate}</TableCell>
//                                                 <TableCell align="right" sx={{ fontSize: '0.75rem' }}>{item.Purc_Rate || item.Mill_Rate}</TableCell>
//                                                 <TableCell align="right" sx={{ fontSize: '0.75rem' }}>{item.Sale_Rate}</TableCell>
//                                                 <TableCell align="right" style={{ color: rowProfit >= 0 ? "green" : "red", fontWeight: "bold", fontSize: '0.75rem' }}>
//                                                     {formatReadableAmount(rowProfit.toFixed(2))}
//                                                 </TableCell>
//                                             </TableRow>
//                                         );
//                                     })}
//                                     <TableRow sx={{ backgroundColor: "#edf0df" }}>
//                                         <TableCell colSpan={6} align="right"><strong>Total for {date}:</strong></TableCell>
//                                         <TableCell align="right"><strong>{formatReadableAmount(group.reduce((t, i) => t + parseFloat(i.Qntl || 0), 0).toFixed(2))}</strong></TableCell>
//                                         <TableCell colSpan={4} align="right"><strong>Subtotal P&L:</strong></TableCell>
//                                         <TableCell align="right" style={{ color: group.reduce((t, i) => t + calculateRowProfit(i), 0) >= 0 ? "green" : "red", fontWeight: "bold" }}>
//                                             {formatReadableAmount(group.reduce((t, i) => t + calculateRowProfit(i), 0).toFixed(2))}
//                                         </TableCell>
//                                     </TableRow>
//                                 </React.Fragment>
//                             ))}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             </Paper>

//             <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="md">
//                 <Box sx={{ backgroundColor: "#3f51b5", color: "white", textAlign: "center", py: 1.2, fontWeight: 600 }}>Edit Live Tender</Box>
//                 <DialogContent sx={{ mt: 1 }}>
//                     <Grid container spacing={1}>
//                         <Grid item xs={12} sm={4}><Typography fontWeight="bold">Buyer:</Typography></Grid>
//                         <Grid item xs={12} sm={8}>
//                             <AccountMasterHelp name="Buyer" CategoryCode={formData.Buyer} CategoryName={buyerName} onAcCodeClick={(code, accoid, name) => { setFormData(p => ({ ...p, Buyer: code, buyerid: accoid })); setBuyerName(name); }} />
//                         </Grid>
//                         <Grid item xs={12} sm={4}><Typography fontWeight="bold">Buyer Quantal:</Typography></Grid>
//                         <Grid item xs={12} sm={8}><TextField size="small" fullWidth name="Buyer_Quantal" type="number" value={formData.Buyer_Quantal} onChange={handleInputChange} /></Grid>
//                         <Grid item xs={12} sm={4}><Typography fontWeight="bold">Sale Rate:</Typography></Grid>
//                         <Grid item xs={12} sm={8}><TextField size="small" fullWidth name="Sale_Rate" type="number" value={formData.Sale_Rate} onChange={handleInputChange} /></Grid>
//                     </Grid>
//                 </DialogContent>
//                 <DialogActions sx={{ justifyContent: "center", mb: 1 }}>
//                     <Button variant="outlined" color="secondary" onClick={() => setOpenEdit(false)}>Cancel</Button>
//                     <Button variant="contained" color="primary" onClick={handleSaveEdit}>Save</Button>
//                 </DialogActions>
//             </Dialog>
//         </Box>
//     );
// };

// export default LiveAllTendersForDailyBasis;





















import React, { useEffect, useState, useRef, useMemo } from "react";
import {
    Box, Grid, Typography, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Divider, Dialog, DialogContent, DialogActions,
    Button, TextField, TableSortLabel, CircularProgress
} from "@mui/material";
import axios from "axios";
import io from "socket.io-client";
import * as XLSX from 'xlsx';
import SearchBar from "../../../../Common/UtilityCommon/SearchBar";
import { formatReadableAmount } from "../../../../Common/FormatFunctions/FormatAmount";
import AccountMasterHelp from "../../../../Helper/AccountMasterHelp";
import PrintButton from "../../../../Common/Buttons/PrintPDF";

// PDF Generator Imports
import { generateReportPDF } from "../../../../Common/ReportCommon/CommonPDFGenerator";
import { ConvertNumberToWord } from "../../../../Common/FormatFunctions/ConvertNumberToWord";
import HeaderJK from '../../../../Assets/HeaderJK.png';
import FooterJK from '../../../../Assets/FooterJK.png';
import { ScaleLoader } from "react-spinners";

const headerCellStyle = {
    fontWeight: "bold",
    backgroundColor: "#3f51b5",
    color: "white",
    padding: "4px",
    fontSize: "0.75rem",
    textAlign: "center",
};

const LiveAllTendersForDailyBasis = () => {
    const apikey = process.env.REACT_APP_API;
    const socketURL = process.env.REACT_APP_API_URL;
    const company_code = sessionStorage.getItem("Company_Code");
    const year_code = sessionStorage.getItem("Year_Code");

    const [tenders, setTenders] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [openEdit, setOpenEdit] = useState(false);
    const [netAmount, setNetAmount] = useState("0.00");
    const [sortConfig, setSortConfig] = useState({ key: 'Sauda_Date', direction: 'desc' });
    const [loading, setLoading] = useState(false); // ← ADDED

    const [formData, setFormData] = useState({
        Tender_No: "", Buyer: "", ShipTo: "", Buyer_Party: "", sub_broker: "",
        buyerid: "", buyerpartyid: "", sbr: "", shiptoid: "", Buyer_Quantal: "",
        Sale_Rate: "", Commission_Rate: "", gst_rate: 5.0, tcs_rate: 0.1,
        gst_amt: 0.0, tcs_amt: 0.0, Delivery_Type: "C",
        Sauda_Date: new Date().toISOString().split("T")[0],
        Lifting_Date: new Date().toISOString().split("T")[0],
        Narration: "", Sauda_Time: new Date().toLocaleTimeString("en-GB", { hour12: false }),
        EbuySelectedParty: "", EbuySelectedAccoid: "", EbuySugarLiftingDate: "",
        Payment_To: "", pt: "",
    });

    const [millName, setMillName] = useState("");
    const [buyerName, setBuyerName] = useState("");
    const [shipToName, setShipToName] = useState("");
    const [brokerName, setBrokerName] = useState("");
    const [subBrokerName, setSubBrokerName] = useState("");
    const [tenderdetailid, settenderDetailId] = useState(0);
    const [tenderNo, setTenderNo] = useState(0);
    const [selectedPartyName, setSelectedPartyName] = useState("");

    const fetchTenders = async () => {
        setLoading(true); // ← ADDED
        try {
            const res = await axios.get(
                `${apikey}/get_live_tendersall?Company_Code=${company_code}&Year_Code=${year_code}`
            );
            if (res.data.all_data) {
                setTenders(res.data.all_data);
            }
        } catch (err) {
            console.error("Error fetching tenders:", err);
        } finally {
            setLoading(false); // ← ADDED
        }
    };

    useEffect(() => {
        const socket = io(`${socketURL}`, { transports: ["websocket"] });
        socket.on("tender_added", fetchTenders);
        socket.on("tender_updated", fetchTenders);
        socket.on("tender_deleted", fetchTenders);
        fetchTenders();
        return () => socket.disconnect();
    }, []);

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const calculateRowProfit = (row) => {
        const purcRate = parseFloat(row?.Purc_Rate) || 0;
        const millRate = parseFloat(row?.Mill_Rate) || 0;
        const saleRate = parseFloat(row?.Sale_Rate) || 0;
        const quantity = parseFloat(row?.Qntl) || 0;
        const effectivePurchaseRate = purcRate > 0 ? purcRate : millRate;
        const profit = (saleRate - effectivePurchaseRate) * quantity;
        return isNaN(profit) ? 0 : parseFloat(profit.toFixed(2));
    };

    const processedData = useMemo(() => {
        let filteredData = tenders.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(searchTerm.toLowerCase())
            )
        );

        if (sortConfig.key) {
            filteredData.sort((a, b) => {
                let aVal = a[sortConfig.key];
                let bVal = b[sortConfig.key];

                if (sortConfig.key === "Sauda_Date") {
                    const [ad, am, ay] = aVal.split("/");
                    const [bd, bm, by] = bVal.split("/");
                    aVal = new Date(`${ay}-${am}-${ad}`);
                    bVal = new Date(`${by}-${bm}-${bd}`);
                } else if (sortConfig.key === "Sauda_Time") {
                    aVal = new Date(`1970-01-01T${aVal}`);
                    bVal = new Date(`1970-01-01T${bVal}`);
                } else if (!isNaN(aVal) && !isNaN(bVal)) {
                    aVal = parseFloat(aVal);
                    bVal = parseFloat(bVal);
                }

                if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
                if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
                return 0;
            });
        }
        return filteredData;
    }, [tenders, searchTerm, sortConfig]);

    const groupedData = useMemo(() => {
        const grouped = {};
        processedData.forEach((item) => {
            if (!grouped[item.Sauda_Date]) grouped[item.Sauda_Date] = [];
            grouped[item.Sauda_Date].push(item);
        });
        return grouped;
    }, [processedData]);

    const handlePrint = () => {
        const columns = ["No", "Date", "Mill", "Buyer", "DO", "Qty", "Grd", "M.Rate", "P.Rate", "S.Rate", "P&L"];
        const rows = [];
        let grandTotalQty = 0;
        let grandTotalProfit = 0;

        const yellowStyle = {
            fillColor: [255, 249, 196],
            fontStyle: 'bold'
        };

        Object.entries(groupedData).forEach(([date, group]) => {
            let subQty = 0;
            let subProfit = 0;

            group.forEach(item => {
                const profit = calculateRowProfit(item);
                subQty += parseFloat(item.Qntl || 0);
                subProfit += profit;

                rows.push([
                    item.Tender_No, item.Sauda_Date, item.Mill, item.buyerName, item.DO,
                    { content: formatReadableAmount(item.Qntl), styles: { halign: 'right' } },
                    item.Grade,
                    { content: formatReadableAmount(item.Mill_Rate), styles: { halign: 'right' } },
                    { content: formatReadableAmount(item.Purc_Rate || item.Mill_Rate), styles: { halign: 'right' } },
                    { content: formatReadableAmount(item.Sale_Rate), styles: { halign: 'right' } },
                    { content: formatReadableAmount(profit.toFixed(2)), styles: { halign: 'right', fontStyle: 'bold' } }
                ]);
            });

            rows.push([
                { content: `Total for ${date}:`, colSpan: 5, styles: { ...yellowStyle, halign: 'right' } },
                { content: formatReadableAmount(subQty.toFixed(2)), styles: { ...yellowStyle, halign: 'right' } },
                { content: '', colSpan: 4, styles: yellowStyle },
                { content: formatReadableAmount(subProfit.toFixed(2)), styles: { ...yellowStyle, halign: 'right' } }
            ]);

            rows.push([
                {
                    content: '------------------------------------------------------------------------------------------------------------------------------------------------------------------',
                    colSpan: 11,
                    styles: {
                        halign: 'center',
                        textColor: [150, 150, 150],
                        fontSize: 8,
                        cellPadding: 1
                    }
                }
            ]);

            grandTotalQty += subQty;
            grandTotalProfit += subProfit;
        });

        generateReportPDF({
            title: 'Daily Sauda Report',
            columns,
            rows,
            footerRow: [
                { content: 'GRAND TOTAL', colSpan: 5, styles: { ...yellowStyle, halign: 'right' } },
                { content: formatReadableAmount(grandTotalQty.toFixed(2)), styles: { ...yellowStyle, halign: 'right' } },
                { content: '', colSpan: 4, styles: yellowStyle },
                { content: formatReadableAmount(grandTotalProfit.toFixed(2)), styles: { ...yellowStyle, halign: 'right' } }
            ],
            orientation: 'landscape',
            headerImgSrc: HeaderJK,
            footerImgSrc: FooterJK,
            styles: { fontSize: 7 },
            onComplete: (url) => window.open(url, "_blank"),
        });
    };

    const handleExportExcel = () => {
        const data = processedData.map(item => ({
            "Tender No": item.Tender_No,
            "Sauda Date": item.Sauda_Date,
            "Mill": item.Mill,
            "Buyer": item.buyerName,
            "DO": item.DO,
            "Quantity": item.Qntl,
            "Grade": item.Grade,
            "Mill Rate": item.Mill_Rate,
            "Purchase Rate": item.Purc_Rate || item.Mill_Rate,
            "Sale Rate": item.Sale_Rate,
            "Profit/Loss": calculateRowProfit(item)
        }));
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Daily Sauda");
        XLSX.writeFile(wb, "Daily_Sauda_Report.xlsx");
    };

    const handleSaveEdit = async () => {
        try {
            await axios.put(`${apikey}/update_tender_detail`, {
                detailData: { ...formData, Company_Code: company_code, Year_Code: year_code, tenderdetailid, Tender_No: tenderNo },
            });
            setOpenEdit(false);
            fetchTenders();
            alert("Tender updated successfully!");
        } catch (err) {
            alert("Error updating tender!");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <Box sx={{ mt: -10 }}>
            <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 'bold', color: '#3f51b5' }}>
                DATE WISE DAILY SAUDA REPORT
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }} style={{ marginLeft: '600px' }}>
                <Box sx={{ flexGrow: 1, maxWidth: '600px' }}>
                    <SearchBar value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <PrintButton fetchData={handlePrint} />
                    <Button
                        variant="contained"
                        color="success"
                        onClick={handleExportExcel}
                        sx={{ textTransform: 'none', fontWeight: 'bold', height: '35px' }}
                    >
                        Export Excel
                    </Button>
                </Box>
            </Box>

            <Paper elevation={3} sx={{ mx: 2 }}>
                {/* ← ADDED LOADER */}
                {loading ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 8, gap: 2 }}>
                        <ScaleLoader size={50} thickness={4} sx={{ color: '#3f51b5' }} />
                        <Typography variant="body2" sx={{ color: '#3f51b5', fontWeight: 600 }}>
                            Loading data, please wait...
                        </Typography>
                    </Box>
                ) : (
                    <TableContainer sx={{ maxHeight: "75vh" }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {[
                                        { id: 'Tender_No', label: 'Tender No' },
                                        { id: 'Sauda_Date', label: 'Sauda Date' },
                                        { id: 'Sauda_Time', label: 'Time' },
                                        { id: 'Mill', label: 'Mill Name' },
                                        { id: 'buyerName', label: 'Buyer Name' },
                                        { id: 'DO', label: 'DO Name' },
                                        { id: 'Qntl', label: 'Quintal' },
                                        { id: 'Grade', label: 'Grade' },
                                        { id: 'Mill_Rate', label: 'Mill Rate' },
                                        { id: 'Purc_Rate', label: 'Purc Rate' },
                                        { id: 'Sale_Rate', label: 'Sale Rate' },
                                        { id: 'profit', label: 'Profit & Loss' }
                                    ].map((col) => (
                                        <TableCell key={col.id} sx={headerCellStyle}>
                                            <TableSortLabel
                                                active={sortConfig.key === col.id}
                                                direction={sortConfig.key === col.id ? sortConfig.direction : 'asc'}
                                                onClick={() => handleSort(col.id)}
                                                sx={{ '& .MuiTableSortLabel-icon': { color: 'white !important' }, color: 'white !important' }}
                                            >
                                                {col.label}
                                            </TableSortLabel>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.entries(groupedData).map(([date, group], gIdx) => (
                                    <React.Fragment key={date}>
                                        {group.map((item, idx) => {
                                            const rowProfit = calculateRowProfit(item);
                                            return (
                                                <TableRow key={`${gIdx}-${idx}`} hover>
                                                    <TableCell sx={{ fontSize: '0.75rem' }}>{item.Tender_No}</TableCell>
                                                    <TableCell sx={{ fontSize: '0.75rem' }}>{item.Sauda_Date}</TableCell>
                                                    <TableCell sx={{ fontSize: '0.75rem' }}>{item.Sauda_Time}</TableCell>
                                                    <TableCell sx={{ fontSize: '0.75rem' }}>{item.Mill}</TableCell>
                                                    <TableCell sx={{ fontSize: '0.75rem' }}>{item.buyerName}</TableCell>
                                                    <TableCell sx={{ fontSize: '0.75rem' }}>{item.DO}</TableCell>
                                                    <TableCell align="right" sx={{ fontSize: '0.75rem' }}>{item.Qntl}</TableCell>
                                                    <TableCell sx={{ fontSize: '0.75rem' }}>{item.Grade}</TableCell>
                                                    <TableCell align="right" sx={{ fontSize: '0.75rem' }}>{item.Mill_Rate}</TableCell>
                                                    <TableCell align="right" sx={{ fontSize: '0.75rem' }}>{item.Purc_Rate || item.Mill_Rate}</TableCell>
                                                    <TableCell align="right" sx={{ fontSize: '0.75rem' }}>{item.Sale_Rate}</TableCell>
                                                    <TableCell align="right" style={{ color: rowProfit >= 0 ? "green" : "red", fontWeight: "bold", fontSize: '0.75rem' }}>
                                                        {formatReadableAmount(rowProfit.toFixed(2))}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                        <TableRow sx={{ backgroundColor: "#edf0df" }}>
                                            <TableCell colSpan={6} align="right"><strong>Total for {date}:</strong></TableCell>
                                            <TableCell align="right"><strong>{formatReadableAmount(group.reduce((t, i) => t + parseFloat(i.Qntl || 0), 0).toFixed(2))}</strong></TableCell>
                                            <TableCell colSpan={4} align="right"><strong>Subtotal P&L:</strong></TableCell>
                                            <TableCell align="right" style={{ color: group.reduce((t, i) => t + calculateRowProfit(i), 0) >= 0 ? "green" : "red", fontWeight: "bold" }}>
                                                {formatReadableAmount(group.reduce((t, i) => t + calculateRowProfit(i), 0).toFixed(2))}
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Paper>

            <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="md">
                <Box sx={{ backgroundColor: "#3f51b5", color: "white", textAlign: "center", py: 1.2, fontWeight: 600 }}>Edit Live Tender</Box>
                <DialogContent sx={{ mt: 1 }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={4}><Typography fontWeight="bold">Buyer:</Typography></Grid>
                        <Grid item xs={12} sm={8}>
                            <AccountMasterHelp name="Buyer" CategoryCode={formData.Buyer} CategoryName={buyerName} onAcCodeClick={(code, accoid, name) => { setFormData(p => ({ ...p, Buyer: code, buyerid: accoid })); setBuyerName(name); }} />
                        </Grid>
                        <Grid item xs={12} sm={4}><Typography fontWeight="bold">Buyer Quantal:</Typography></Grid>
                        <Grid item xs={12} sm={8}><TextField size="small" fullWidth name="Buyer_Quantal" type="number" value={formData.Buyer_Quantal} onChange={handleInputChange} /></Grid>
                        <Grid item xs={12} sm={4}><Typography fontWeight="bold">Sale Rate:</Typography></Grid>
                        <Grid item xs={12} sm={8}><TextField size="small" fullWidth name="Sale_Rate" type="number" value={formData.Sale_Rate} onChange={handleInputChange} /></Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", mb: 1 }}>
                    <Button variant="outlined" color="secondary" onClick={() => setOpenEdit(false)}>Cancel</Button>
                    <Button variant="contained" color="primary" onClick={handleSaveEdit}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default LiveAllTendersForDailyBasis;